import { FormErrors } from 'app/shared/validators/generic-validators';
import { MdDialogRef } from '@angular/material';
import { MapsAPILoader } from '@agm/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, ElementRef, OnInit, OnChanges, ViewChild, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';

import { unsavedFormCheck } from 'app/shared/validators/generic-validators';

import { Document } from 'app/shared/models/document.model';
import { User } from 'app/shared/models/user.model';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { EntityDocumentsService } from 'app/entities/documents/entity-documents.service';

@Component({
  selector: 'add-label',
  templateUrl: './add-label.component.html',
})

export class AddLabelComponent implements OnInit {
  public entityId: number;
  private addLabelForm: FormGroup;
  selectedDocument: Document;
  labels = [];

  constructor(
    public dialogRef: MdDialogRef<any>,
    private formBuilder: FormBuilder,
    private snackBarService: SnackBarService,
    private warmUpService: WarmUpService,
    private entityDocumentsService: EntityDocumentsService
  ) { }

  ngOnInit() {
    this.addLabelForm = this.formBuilder.group({
      selectedLabel: ['', Validators.required]
    });

    this.entityDocumentsService.getDocumentLabels().subscribe(
      response => {
        this.labels = response.arrResult['values'];
      }
    );
  }

  onSubmit({ value, valid }): void {
    const docLabels = {
      id: this.selectedDocument.id,
      labelId: value.selectedLabel
    };

    this.entityDocumentsService.addDocumentLabel(docLabels)
      .subscribe(response => {
        this.callSnackBarService(response, MessageService.ADDED_DOCUMENT_LABELS_SUCCESS);
        this.dialogRef.close(response);
      }, err => {
        this.callSnackBarService(err, '');
      });
  }

  callSnackBarService(response: any, successMsg) {
    this.snackBarService
      .showStatus(response,
      successMsg,
      MessageService.DOCUMENT_FAILURE);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/documents/addlabel/add-label.component.ts